// React Imports
import type { SVGAttributes } from 'react'

const Logo = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <defs>
        <linearGradient id='qualitelLogoGradient' x1='80' y1='80' x2='430' y2='430' gradientUnits='userSpaceOnUse'>
          <stop offset='0%' stopColor='#fe7938' />
          <stop offset='100%' stopColor='#821f89' />
        </linearGradient>
      </defs>
      <rect x='48' y='48' width='416' height='416' rx='96' fill='#fff' />
      <circle cx='256' cy='260' r='145' fill='none' stroke='url(#qualitelLogoGradient)' strokeWidth='42' />
      <path d='M350 360L420 430' stroke='#821f89' strokeWidth='42' strokeLinecap='round' />
      <path
        d='M165 205C185 165 218 150 250 165C274 176 292 174 315 154C323 147 335 150 336 162C338 185 324 199 302 204C286 208 270 208 253 202L240 235H218L226 202C205 202 188 207 175 222Z'
        fill='#fe7938'
      />
      <path d='M190 285L235 330L325 240' stroke='#821f89' strokeWidth='34' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

export default Logo
